import { render } from "./childTopicPieEcharts.vue?vue&type=template&id=822f390a&scoped=true"
import script from "./childTopicPieEcharts.vue?vue&type=script&lang=js"
export * from "./childTopicPieEcharts.vue?vue&type=script&lang=js"

import "./childTopicPieEcharts.vue?vue&type=style&index=0&id=822f390a&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822f390a"]])

export default __exports__